export const DATE_FORMAT = "YYYY-MM-DD"
export const HUMAN_DATE_FORMAT = "DD/MM/YYYY"
export const TIME_FORMAT = "HH:mm"
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm"
export const MONTH_FORMAT = "YYYY-MM"

export const SECONDARY_SCREEN_NAME = "ahc-secondary-screen";

export const USER_GROUP = {
	WEIGHT : "weight",
	LAB : "lab",
	POND : "pond",
	TANK : "tank",
	SALE : "sale",
	PURCHASE : "purchase",
	CHEMICAL : "chemical",
	SKIM : "skim",
	MANAGER : "manager",
	WT_LATEX : "wt_latex",
	WT_CONCENTRATED : "wt_concentrated",
	WEIGHT_MANAGER : "weight_manager",
	QC : "qc",
	RP : "rp",
	PAYMENT_REPORT : "payment_report",
}

export const TRUCK_ACTION = {
	APPROVE : "approve",
	REJECT : "reject",
	PRICE_CONFIRM : "price-confirm",
	REVERT : "undo-price-confirmation",
}

export const LAB_ORDER_TYPE = {
	TRUCK: "truck",
	POND: "pond",
	TANK: "tank",
	SKIM: "skim",
	// for lab pond and tank screen
	LAB_POND: "lab_pond",
	LAB_TANK: "lab_tank",
}

export const LAB_ORDER_TYPE_TH = {
	[LAB_ORDER_TYPE.TRUCK] : "น้ำยางสด",
	[LAB_ORDER_TYPE.POND]: "บ่อน้ำยางสด",
	[LAB_ORDER_TYPE.TANK]: "แทงก์น้ำยางข้น",
	[LAB_ORDER_TYPE.SKIM]: "สกิม",
}

export const LAB_TYPE_OPTIONS = [
	{ key : 'all', label: "ทั้งหมด" , value: '' },
	{ key : LAB_ORDER_TYPE.TRUCK, label: LAB_ORDER_TYPE_TH[LAB_ORDER_TYPE.TRUCK] , value: LAB_ORDER_TYPE.TRUCK },
	{ key : LAB_ORDER_TYPE.POND, label: LAB_ORDER_TYPE_TH[LAB_ORDER_TYPE.POND], value: LAB_ORDER_TYPE.POND },
	{ key : LAB_ORDER_TYPE.TANK, label: LAB_ORDER_TYPE_TH[LAB_ORDER_TYPE.TANK], value: LAB_ORDER_TYPE.TANK },
	{ key : LAB_ORDER_TYPE.SKIM, label: LAB_ORDER_TYPE_TH[LAB_ORDER_TYPE.SKIM], value: LAB_ORDER_TYPE.SKIM }
]

export const LAB_ORDER_DETAIL = {
	INDEX: 'index',
	SUPPLIER_NAME : 'supplier_name',
	VEHICLE_LICENSE_PLATE : 'vehicle_license_plate',
	SUBSTITUTE_LICENSE_PLATE : 'substitute_license_plate',
	LOT_NO : 'lot_no',
	GRADE_NAME: 'grade_name',
	PRODUCT_NAME : 'product_name',
	STATE : 'state',
	CURRENT_WEIGHT : 'current_weight',
	CURRENT_HEIGHT : 'current_height',
	CURRENT_AMOUNT : 'current_amount',
}

export const PURE_CHEMICAL_STATUS = {
	PASS : true,
	NOT_PASS : false,
}

export const PURE_CHEMICAL_STATUS_TH = {
	[PURE_CHEMICAL_STATUS.PASS] : 'ผ่าน',
	[PURE_CHEMICAL_STATUS.NOT_PASS] : 'ไม่่ผ่าน',
}

export const LAB_ORDER_DETAIL_TH = {
	// [LAB_ORDER_DETAIL.SUPPLIER_NAME] : 'ชื่อผู้ขาย',
	[LAB_ORDER_DETAIL.INDEX] : 'ลำดับ',
	[LAB_ORDER_DETAIL.VEHICLE_LICENSE_PLATE] : 'ทะเบียน',
	[LAB_ORDER_DETAIL.SUBSTITUTE_LICENSE_PLATE] : 'ทะเบียนแทน',
	[LAB_ORDER_DETAIL.LOT_NO] : 'เลข lot',
	[LAB_ORDER_DETAIL.GRADE_NAME] : 'เกรด',
	[LAB_ORDER_DETAIL.PRODUCT_NAME] : 'สินค้า',
	[LAB_ORDER_DETAIL.STATE] : 'สถานะ',
	[LAB_ORDER_DETAIL.CURRENT_WEIGHT] : 'น้ำหนักปัจจุบัน',
	[LAB_ORDER_DETAIL.CURRENT_AMOUNT] : 'จำนวนปัจจุบัน',
	[LAB_ORDER_DETAIL.CURRENT_HEIGHT] : 'ความสูงวัดเทียบปัจจุบัน',
}

export const POND_STATUS = {
	EMPTY : 'empty',
	FILLING : 'filling',
	CLOSED : 'closed',
	PRODUCING : 'producing',
	END : 'end',
}

export const POND_STATUS_TH = {
	[POND_STATUS.EMPTY] : 'บ่อว่าง',
	[POND_STATUS.FILLING] : 'เติมน้ำยาง',
	[POND_STATUS.CLOSED] : 'ปิดบ่อ',
	[POND_STATUS.PRODUCING] : 'ผลิต',
	[POND_STATUS.END] : 'จบการทำงาน'
}

export const POND_ACTION = {
	CLOSE : 'close',
	PRODUCE : 'produce',
	END : 'end',
	REVERT : 'revert'
}


export const POND_STATUS_OPTIONS = [
	{ key : 'all', label: "ทั้งหมด" , value: '' },
	{ key : POND_STATUS.FILLING, label: POND_STATUS_TH[POND_STATUS.FILLING] , value: POND_STATUS.FILLING },
	{ key : POND_STATUS.CLOSED, label: POND_STATUS_TH[POND_STATUS.CLOSED], value: POND_STATUS.CLOSED },
	{ key : POND_STATUS.PRODUCING, label: POND_STATUS_TH[POND_STATUS.PRODUCING], value: POND_STATUS.PRODUCING },
	{ key : POND_STATUS.END, label: POND_STATUS_TH[POND_STATUS.END], value: POND_STATUS.END }
]

export const LAB_ACTION = {
	LAB : 'lab',
	INPUT : 'input',
	COMPLETE : 'complete',
	REVERT : 'revert',
}

export const PRODUCT_TYPE = {
	CONCENTRATE_LATEX : 'concentrate_latex',
	SKIM : 'skim'
}

export const TANK_ACTION = {
	CLOSE : 'close',
	SELL : 'sell',
	END : 'end',
	REVERT : 'revert'
}

export const TANK_STATUS = {
	FILLING : 'filling',
	EMPTY : 'empty',
	CLOSED : 'closed',
	SELLING : 'selling',
	END : 'end'
}

export const TANK_STATUS_TH = {
	[TANK_STATUS.FILLING] : 'เติมน้ำยาง',
	[TANK_STATUS.EMPTY] : 'แทงก์ว่าง',
	[TANK_STATUS.CLOSED] : 'ปิดแทงก์',
	[TANK_STATUS.SELLING] : 'ขาย',
	[TANK_STATUS.END] : 'จบการทำงาน'
}

export const TANK_STATUS_OPTIONS = [
	{ key : 'all', label: "ทั้งหมด" , value: '' },
	{ key : TANK_STATUS.FILLING, label: TANK_STATUS_TH[TANK_STATUS.FILLING] , value: TANK_STATUS.FILLING },
	{ key : TANK_STATUS.CLOSED, label: TANK_STATUS_TH[TANK_STATUS.CLOSED], value: TANK_STATUS.CLOSED },
	{ key : TANK_STATUS.SELLING, label: TANK_STATUS_TH[TANK_STATUS.SELLING], value: TANK_STATUS.SELLING },
	{ key : TANK_STATUS.END, label: TANK_STATUS_TH[TANK_STATUS.END], value: TANK_STATUS.END }
]

export const DELIVERY_ACTION = {
	COMPLETE : 'complete',
	REVERT : 'revert'
}

export const QUALITY_CHEMICAL_TYPE = {
	POND : 'pond',
	TANK : 'tank'
}

export const QUALITY_CHEMICAL_TYPE_OPTIONS = [
	{ key : QUALITY_CHEMICAL_TYPE.POND, label: 'บ่อพักน้ำยางสด', value: QUALITY_CHEMICAL_TYPE.POND },
	{ key : QUALITY_CHEMICAL_TYPE.TANK, label: 'แทงก์น้ำยางข้น', value: QUALITY_CHEMICAL_TYPE.TANK }
]

export const LAB_RESULT = {
	SUCCESS : 'success',
	WARNING : 'warning',
	DANGER : 'danger',
}

export const VEHICLE_TYPE = {
	TRUCK : 'truck',
	PICK_UP : 'pick_up',
	CAR : 'car',
	MOTORCYCLE : 'motorcycle'
}

export const SKIM_STATUS = {
	FILLING : 'filling',
	CLOSED : 'closed',
	END : 'end',
}


export const SKIM_STATUS_TH = {
	[SKIM_STATUS.FILLING] : 'กำลังเติม',
	[SKIM_STATUS.CLOSED] : 'ปิดบ่อ',
	[SKIM_STATUS.END] : 'จบการทำงาน',
}

export const SKIM_STOCK_ACTION_TH = {
	'add' : 'เพิ่มสต๊อก',
	'withdraw' : 'ตัดสต๊อก'
}

export const LICENSE_PLATE_TYPE = {
	MAIN : 'main',
	SUBTITUTE : 'substitute'
}

 // FOR REPORT
export const REPORT_FILTER = {
	DATE: "date",
	DATE_RANGE: "date_range",
	MONTH: "month",
	MONTH_RANGE: "month_range",
	BUYER: "buyer",
	BANK_ACCOUNT: "account_id",
	PURE_CHEMICAL: "pure_chemical",
	TANK_TRANSACTION: "tank_transaction",
	SALE_ORDER: "sale_order",
	TABLE_TANK_TRANSACTION: "table_tank_transaction",
	TABLE_SALE_ORDER: "table_sale_order",
	TABLE_SALE_ORDER_SKIM: "table_sale_order_skim",
	SKIM_CHEMICAL: "skim_chemical",
	RAW_LATEX_CUSTOMER: "customer",
	DELIVERY_SERIAL_ID: 'serial_id',
	RAW_LATEX_SUPPLIER: "supplier",
	NO: "no",
}

export const REPORT_FILTER_TH = {
	[REPORT_FILTER.DATE] : 'วันที่',
	[REPORT_FILTER.DATE_RANGE] : 'ช่วงวันที่',
	[REPORT_FILTER.MONTH] : 'เดือน',
	[REPORT_FILTER.MONTH_RANGE] : 'ช่วงเดือน',
	[REPORT_FILTER.BUYER] : 'ผู้ขาย',
	[REPORT_FILTER.BANK_ACCOUNT] : 'บัญชีบริษัท',
	[REPORT_FILTER.PURE_CHEMICAL] : 'เคมีภัณฑ์',
	[REPORT_FILTER.TANK_TRANSACTION] : 'ล็อตแทงก์',
	[REPORT_FILTER.SALE_ORDER] : 'รายการสั่งซื้อ',
	[REPORT_FILTER.TABLE_TANK_TRANSACTION] : 'รายการแทงก์น้ำยางข้น',
	[REPORT_FILTER.TABLE_SALE_ORDER] : 'รายการขายน้ำยางข้น',
	[REPORT_FILTER.TABLE_SALE_ORDER_SKIM] : 'รายการขายสกิม',
	[REPORT_FILTER.SKIM_CHEMICAL] : 'สารเคมีสกิม',
	[REPORT_FILTER.RAW_LATEX_CUSTOMER] : 'ลูกค้า',
	[REPORT_FILTER.DELIVERY_SERIAL_ID] : 'Serial ID',
	[REPORT_FILTER.RAW_LATEX_SUPPLIER] : 'ผู้ขายน้ำยางสด',
	[REPORT_FILTER.NO] : 'เลขที่',
}

export const LAB_STATUS = {
	ALL: 'all',
	PROGRESSING: 'progressing',
	LAB_COMPLETE: 'lab_complete',
	INPUT_PROGRESSING: 'input_progressing',
	COMPLETE: 'complete',
}